// uses ./appSuggestion.less
import PropTypes from 'prop-types';

import React from 'react';
import behalfSuggestions from '@integrations/pint-appstore-commons/src/components/behalfSuggestions';
import ConfirmationModal from '../common/ConfirmationModal';

class SuggestionFormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appName: '',
            description: '',
            domain: '',
            validationErrors: null,
        };
        this.handleAppNameChange = this.handleAppNameChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleDomainChange = this.handleDomainChange.bind(this);
        this.submitSuggestion = this.submitSuggestion.bind(this);
    }

    handleAppNameChange(e) {
        this.setState({
            appName: e.target.value,
        });
    }

    handleDescriptionChange(e) {
        this.setState({
            description: e.target.value,
        });
    }

    handleDomainChange(e) {
        this.setState({
            domain: e.target.value,
            validationErrors: null,
        });
    }

    submitSuggestion() {
        if (this.state.domain && !behalfSuggestions.isValidDomain(this.state.domain)) {
            return this.setState({
                validationErrors: {
                    domain: 'customer domain should match the pattern subdomain.egnyte.com',
                },
            });
        }
        this.props.submitSuggestion(this.state.appName, this.state.description, this.state.domain);
    }

    render() {
        const onBehalfComponent = this.props.isBehalfOfCustomerEnabled ? (
            <div>
                <label className="appSuggestion-label" htmlFor="appSuggestion-domain">
                    Suggestion on behalf of customer domain
                </label>
                <input
                    className="appSuggestion-domain"
                    id="appSuggestion-domain"
                    value={this.state.domain}
                    onChange={this.handleDomainChange}
                    placeholder="example.egnyte.com"
                />
                <p className="appSuggestion__validation-error-message">
                    {this.state.validationErrors && this.state.validationErrors.domain}
                </p>
            </div>
        ) : null;

        return (
            <ConfirmationModal
                className="appSuggestion"
                closeHandler={this.props.closeSuggestion}
                title="Which product would you like to integrate with Egnyte?"
                confirmHandler={this.submitSuggestion}
                confirmLabel="Send"
                isFetching={this.props.isFetching}
                isDisabled={!this.state.appName || !this.state.description || !!this.state.validationErrors}
                loadingMessage="Sending your message..."
            >
                <form>
                    <label className="appSuggestion-label" htmlFor="appSuggestion-appName">
                        Name of the app to integrate:
                    </label>
                    <input
                        type="text"
                        className="appSuggestion-name"
                        id="appSuggestion-appName"
                        value={this.state.appName}
                        onChange={this.handleAppNameChange}
                    />

                    <label className="appSuggestion-label" htmlFor="appSuggestion-description">
                        How do you want to use this app?
                    </label>
                    <textarea
                        className="appSuggestion-description"
                        id="appSuggestion-description"
                        value={this.state.description}
                        onChange={this.handleDescriptionChange}
                        placeholder="Help us with making this integration brilliant for you."
                    />
                    {onBehalfComponent}
                </form>
            </ConfirmationModal>
        );
    }
}

SuggestionFormModal.propTypes = {
    submitSuggestion: PropTypes.func.isRequired,
    closeSuggestion: PropTypes.func.isRequired,
    isBehalfOfCustomerEnabled: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
};
export default SuggestionFormModal;
